import { NAV_SECTION_SET } from '../constants/ActionTypes';

const initialState = {
  activeSection: 'dashboard',
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case NAV_SECTION_SET:
      return {
        ...state,
        activeSection: action.activeSection
      };
    default:
      return state;
  }
}
